import React from 'react'
import './app.scss'
import { Route, Redirect, Switch, BrowserRouter as Router } from 'react-router-dom'
import HomePage from './screens/homePage/HomePage'
import PricePlan from './screens/pricePlan/PricePlan'
import CallCenterService from './screens/callCenterService/CallCenterService'
import Services from './screens/services/Services'
import Contact from './screens/contactPage/ContactPage'
import NavigationBar from './components/navigationBar/NavigationBar'
import TermsPage from './screens/termsPage/TermsPage'
import PrivacyPage from './screens/termsPage/PrivacyPage'
import PageNotFound from './screens/pageNotFound/PageNotFound'
import Pricing from './screens/pricing/Pricing'
import AboutPage from './screens/aboutPage/AboutPage'
import ScrollButton from './components/scrollButton/ScrollButton'
import { CountryContext } from './hooks/CountryContext'
import PaymentPage from './screens/paymentPage/PaymentPage'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Coverage from './screens/coverage/Coverage'
import Details from './screens/coverage/Details'
import PromoPage from './screens/promoPage/PromoPage';

const App = () => {
  (function(o,l,a,r,k,y){if(o.olark)return; r="script";y=l.createElement(r);r=l.getElementsByTagName(r)[0]; y.async=1;y.src="//"+a;r.parentNode.insertBefore(y,r); y=o.olark=function(){k.s.push(arguments);k.t.push(+new Date)}; y.extend=function(i,j){y("extend",i,j)}; y.identify=function(i){y("identify",k.i=i)}; y.configure=function(i,j){y("configure",i,j);k.c[i]=j}; k=y._={s:[],t:[+new Date],c:{},l:a}; })(window,document,"static.olark.com/jsclient/loader.js");
  /* custom configuration goes here (www.olark.com/documentation) */
  // eslint-disable-next-line no-undef
  olark.identify('2082-461-10-5291');
  
  return (
    <CountryContext>
      <div className="app__style ">
        <Router>
          <NavigationBar />
          <ScrollButton />
          <ScrollToTop />
          <Switch>
            <Route path="/" exact component={HomePage} />
            <Route path="/services" exact component={Services} />
            <Route path="/coverage" exact component={Coverage} />
            <Route path="/coverage/:area_id" exact component={Details} />
            <Route path="/pricing/dedicated-services" exact component={Pricing} />
            <Route path="/pricing/answering-services" exact component={Pricing} />
            <Route path="/contact" exact component={Contact} />
            <Route path="/terms-and-conditions" exact component={TermsPage} />
            <Route path="/privacy-policy" exact component={PrivacyPage} />
            <Route path="/price-plan" exact component={PricePlan} />
            <Route path="/pay" exact component={PaymentPage} />
            <Route path="/customize" exact component={PaymentPage} />
            <Route path="/about" exact component={AboutPage} />
            <Route path="/call-center-service" exact component={CallCenterService} />
            <Route path="/promo/signup" exact component={PromoPage} />
            <Route path="/page-not-found" component={Services} />
            <Redirect to="/page-not-found" />
          </Switch>
        </Router>
        <ScrollButton />
      </div>
    </CountryContext>
  )
}

export default App
